<template>
  <basic-container>
    <el-form
      :model="searchForm"
      ref="searchFormRef"
      label-width="100px"
      label-suffix=":"
      v-show="searchBoxFlag"
    >
      <el-row :gutter="24">
        
        <el-col :span="6">
          <el-form-item label="项目名称" prop="projectId">
            <el-select
              v-model="searchForm.projectId"
              style="width: 100%"
              placeholder="项目名称"
              @change="projectIdChange"
            >
              <el-option
                v-for="item in projectIdList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>

        
        <el-col :span="6">
          <el-form-item label="服务商" prop="providerId">
            <el-select  :disabled="model==='view'" v-model="searchForm.providerId" style="width: 100%" placeholder="服务商">
              <el-option
                v-for="item in providerList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>


        <el-col :span="6">
          
          <el-form-item label="服务人员" prop="realName">
            <el-input
              clearable
               :disabled="model==='view'" v-model="searchForm.realName"
              placeholder="服务人员"
              maxlength="100"
            ></el-input>
          </el-form-item>
        </el-col>


        

        <el-col :span="6">
          
          <el-form-item label="联系方式" prop="phone">
            <el-input
              clearable
               :disabled="model==='view'" v-model="searchForm.phone"
              placeholder="联系方式"
              maxlength="100"
            ></el-input>
          </el-form-item>
        </el-col>


        


        <el-col :span="24">
          <div style="float: right">
            <el-button type="primary" icon="el-icon-search" @click="searchRecord" size="small">
              搜索
            </el-button>
            <el-button icon="el-icon-delete" @click="searchClear" size="small"> 清空 </el-button>
          </div>
        </el-col>
      </el-row>
    </el-form>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      ref="crud"
      @on-load="onLoad"
      @current-change="currentChange"
      @size-change="sizeChange"
      @refresh-change="onLoad"
      @selection-change="selectionChange"
    >
      <template slot="menuRight">
        <searchFromShow
          :searchBoxFlag.sync="searchBoxFlag"
          :removeHeight="searchHeight"
          :option="option"
          reduceHeight="20"
          :refOption="$refs.crud"
        ></searchFromShow>
      </template>

        <!-- v-if="permissionList.addBtn"  -->
      <template slot="menuLeft">
        <el-button 
        type="primary" size="small" @click="addNursingForm"> 新 增</el-button>
      </template>
      <template slot-scope="scope" slot="menu">
        <el-button type="text" size="small" @click="viewRecord(scope.row)">查看 </el-button>
        <el-button type="text" size="small" @click="editRecord(scope.row)">编辑 </el-button>

        <!-- <el-button type="text" size="small" @click="deleteFun(scope.row.id)">删除 </el-button> -->
        <el-button v-if="scope.row.status == 1 " type="text" size="small" @click="switchFun(scope.row.id,scope.row.status)">停用 </el-button>
        <el-button v-if="scope.row.status == 0 " type="text" size="small" @click="switchFun(scope.row.id,scope.row.status)">启用 </el-button>
        <!-- <el-button type="text" size="small" @click="serveFun(scope.row)">服务管理 </el-button> -->
        <el-button type="text" size="small" @click="staticFun(scope.row)">服务统计</el-button>
        
      </template>
    </avue-crud>

    <itemList ref="itemList"></itemList>
    <hr-dialog
      :title="formModel==='add'?'新增':formModel==='edit'?'编辑':'查看'"
      :allowFull="false"
      width="60%"
      :visible.sync="nursingFormVisible"
    >
      <template slot="body">
        <braceletForm
          :model="formModel"
          :row="formRow"
          @cancle="recordCancle"
          v-if="nursingFormVisible"
          @success="recordSuccess"
          :projectId="this.searchForm.projectId"
        ></braceletForm>
      </template>
    </hr-dialog>




    
    <hr-dialog
      :title="'服务管理'"
      :allowFull="false"
      width="60%"
      :visible.sync="serveManageVisible"
    >
      <template slot="body">
        <serviceForm
          :model="formModel"
          :row="formRow"
          @cancle="recordCancle"
          v-if="serveManageVisible"
          @success="recordSuccess"
          :projectId="this.searchForm.projectId"
        ></serviceForm>
      </template>
    </hr-dialog>

    <hr-dialog
      :title="'服务统计'"
      :allowFull="false"
      width="60%"
      :visible.sync="serveStaticsVisible"
    >
      <template slot="body">
        <staticForm
          :model="formModel"
          :row="formRow"
          @cancle="recordCancle"
          v-if="serveStaticsVisible"
          @success="recordSuccess"
          :projectId="this.searchForm.projectId"
        ></staticForm>
      </template>
    </hr-dialog>


  </basic-container>
</template>
  <script>
import { getProjectList } from '@/api/crmedical/project/project';
import { stockWarnPage, getWarehouseList, stockWarnDelete, getProviderUserList } from '../api/serveItemManage.js';
import braceletForm from './braceletForm.vue';
import serviceForm from './serviceForm.vue';
import staticForm from './staticForm.vue';
import { getDictionary } from '@/api/common.js';
import searchFromShow from '@/components/search-form-show/index';
import { mapGetters } from 'vuex';
import { getProviderList, submitServiceInfo, getServiceProviderPage, getNursinghome, getWristbandPage, getDeviceTypeList, wristbandRemove, deviceStart, deviceStop,updateUserStatus } from '../api/serveItemManage';
export default {
  components: { serviceForm, braceletForm, staticForm },
  data() {
    return {
      serveStaticsVisible: false,
      serveManageVisible: false,
      editVisible: false,
      formModel: 'add',
      isImportDialogShow: false,
      settingTotalWarnVisible: false,
      nursingFormVisible: false,
      printVisible: false,
      addOrderVisible: false,
      alarmRuleVisible: false,
      alarmRuleTittle: '编辑',
      alarmRuleModel: 'view',
      rowInfo: {},
      searchForm: {
        projectId: '',
        nursinghomeId: '',
        warehouseId: '',
        type: "",
        consumableCode: '',
        consumableName: '',
        specification: '',
        upWarnFlag: 'false',
        downWarnFlag: 'false',
      },
statusList:[
        {
          dictKey: '0',
          dictValue: '禁用',
        },
        {
          dictKey: '1',
          dictValue: '启用',
        }],
      projectList: [],

      provideList: [
        {
          dickey: '0',
          dicvalue: '购买',
        },
        {
          dickey: '1',
          dicvalue: '免费',
        },
      ],
      option: {
        selection: false,
        select: true,
        index: true,
        indexLabel: '#',
        page: true,
        height: 'auto',
        calcHeight: 'auto',
        align: 'left',
        menu: true,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        border: true,
        column: [
          {
            label: '服务人员',
            prop: 'realName',
          },
          {
            label: '所属服务商',
            prop: 'providerName',
          },
          {
            label: '联系方式',
            prop: 'phone',
          },
          {
            label: '性别',
            prop: 'sex',
                  type: "select",
                  dicData: [
                    {
                      label: "男",
                      value: "1"
                    },
                    {
                      label: "女",
                      value: "2"
                    },
                    {
                      label: "未知",
                      value: "3"
                    }
                  ],
          },
          {
            label: '出生年月',
            prop: 'birthday',
          },
          {
            label: '住址',
            prop: 'address',
          },
          {
            label: '启用状态',
            prop: 'status',
                  type: "select",
                  dicData: [
                    {
                      label: "禁用",
                      value: 0
                    },
                    {
                      label: "启用",
                      value: 1
                    }
                  ],
          },
          
        ],
      },
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      loading: false,
      searchBoxFlag: true,
      searchHeight: '',
      selectionList: [],
      recordIds: [],
      canteenList: [],
      warehouseList: [],
      selectionIds: '',
      formRow: {},
      nursinghomeIdList: [],
      deviceTypeIdList:[],
      onlineStatusList:[],
      deviceStatuseList:[],
      projectIdList:[],
      provideTypeList:[],
      moduleTypeList:[],
      providerList:[],
    };
  },
  created() {
    this.initData();
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        switchBtn: this.vaildData(this.permission.bracelet_switch, false),
        viewBtn: this.vaildData(this.permission.deviceManage_view, false),
        addBtn: this.vaildData(this.permission.deviceManage_add, false),
        editBtn: this.vaildData(this.permission.deviceManage_edit, false),
        delBtn: this.vaildData(this.permission.deviceManage_del, false),
      };
    },
  },
  mounted() {
    this.calcHeight();
  },
  methods: {
    staticFun(row){
      console.log("staticFun=============>",row);
      this.formRow = row;
      this.formModel = 'edit';
      this.serveStaticsVisible = true;
      this.editVisible = true;
    },
    projectIdChange(id){
      
      getProviderList({projectId:this.searchForm.projectId,status:'1'}).then(res=>{
        this.providerList = res.data;
      });
    },
    serveFun(row){
      this.formRow = row;
      this.formModel = 'edit';
      this.serveManageVisible = true;
      this.editVisible = true;
    },
    switchFun(id,status){
      if(status==0){
        updateUserStatus({id:id,status:1}).then(res=>{
          this.$message.success('操作成功！');
          this.onLoad();
        })
      }
      
      if(status==1){
        updateUserStatus({id:id,status:0}).then(res=>{
          this.$message.success('操作成功！');
          this.onLoad();
        })
      }
      
    },
    openItemDetail(row) {
      this.$refs.itemList.openItemListOnload(row.id, row.name);
    },
    addNursingForm() {
      this.formRow = {projectId:this.searchForm.projectId};
      this.formModel = 'add';
      this.nursingFormVisible = true;
    },
    importSuccess() {
      this.isImportDialogShow = false;
      this.onLoad();
    },

    deleteFun(id) {
      this.$confirm(' 是否删除该数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          wristbandRemove(id).then((re) => {
            this.$message.success('删除成功');
            this.onLoad();
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作',
          });
        });
    },

    editRecord(row) {
      this.formRow = row;
      this.formModel = 'edit';
      this.nursingFormVisible = true;
      this.editVisible = true;
    },
    settingTotalWarn() {
      this.formModel = 'add';
      this.settingTotalWarnVisible = true;
    },
    importFun() {
      this.isImportDialogShow = true;
    },
    nursingForm() {
      this.formModel = 'add';
      this.nursingFormVisible = true;
    },

    recordCancle() {
      this.serveManageVisible = false;
      this.editVisible = false;
      this.nursingFormVisible = false;
      this.settingTotalWarnVisible = false;
      this.serveStaticsVisible = false;
    },
    recordSuccess() {
      this.serveManageVisible = false;
      this.editVisible = false;
      this.nursingFormVisible = false;
      this.settingTotalWarnVisible = false;
      this.serveStaticsVisible = false;
      this.onLoad();
    },
    viewRecord(row) {
      this.formRow = row;
      this.formModel = 'view';
      this.nursingFormVisible = true;
      this.editVisible = true;
    },

    addRecord() {
      this.alarmRuleTittle = '新增';
      this.alarmRuleVisible = true;
      this.rowInfo = {
        projectId: this.searchForm.projectId,
      };
      this.alarmRuleModel = 'add';
    },

    stopCanteen() {
      this.alarmRuleVisible = true;
    },
    // nursinghomeIdChange(nursinghomeId) {
      
          
    //       getDeviceTypeList({id: nursinghomeId}).then((res)=>{
    //         this.deviceTypeIdList = res.data;
    //       });
    //   // this.searchForm.warehouseId = '';
      
    //   // this.warehouseList = [];
    //   // getWarehouseList({ nursinghomeId: this.searchForm.nursinghomeId }).then((res) => {
    //   //   this.warehouseList = res.data;
    //   // });
    //   // //  getCanteenName({nursinghomeId:nursinghomeId}).then(res=>{
    //   // //           this.canteenList = res.data
    //   // //        })
    //   // this.getDeptList(this.searchForm.nursinghomeId);
    //   // this.getCanteen(this.searchForm.nursinghomeId);
    // },
    searchRecord() {
      this.page.currentPage = 1;
      if (this.searchForm.upWarnFlag == '') {
        this.searchForm.upWarnFlag = false;
      }
      if (this.searchForm.downWarnFlag == '') {
        this.searchForm.downWarnFlag = false;
      }
      this.onLoad();
    },
    searchClear() {
      this.tool.clearObject(this.searchForm, 'projectId');
      this.searchForm.type = '';
    },

    calcHeight() {
      this.searchHeight = this.$refs.searchFormRef.$el.clientHeight;
      this.option.height = this.bodyHeight - this.searchHeight - 279 - 20;
    },
    initData() {
      
      getProjectList().then(res=>{
        this.projectIdList = res.data;
        this.searchForm.projectId = res.data[0].id;
        
      getProviderList({projectId:this.searchForm.projectId,status:'1'}).then(res=>{
        this.providerList = res.data;
      });
        this.onLoad();
      })
      // getNursinghome().then((res) => {
      //   this.nursinghomeIdList = res.data;
      //   if (this.nursinghomeIdList.length > 0) {
      //     this.$set(this.searchForm, 'nursinghomeId', this.nursinghomeIdList[0].id);
      //     // getWarehouseList({ nursinghomeId: this.searchForm.nursinghomeId }).then((res) => {
      //     //   this.warehouseList = res.data;
      //     // });
          
      //     getDeviceTypeList({id: this.searchForm.nursinghomeId}).then((res)=>{
      //       this.deviceTypeIdList = res.data;
      //     });
      //     this.onLoad();
      //   }
      // });
      // getDictionary('nursinghome_online_status_type').then((res) => {
      //   this.onlineStatusList = res.data;
      // });
      // getDictionary('nursinghome_device_statuse_type').then((res) => {
      //   this.deviceStatuseList = res.data;
      // });
      // getDictionary('nursinghome_release_mode_type').then((res) => {
      //   this.provideList = res.data;
      // });
      // getDictionary('out_order_service_provider_type').then((res) => {
      //   this.provideTypeList = res.data;
      // });
      // getDictionary('out_order_module_type').then((res) => {
      //   this.moduleTypeList = res.data;
      // });
    },

    onLoad() {
      if (this.searchForm.projectId != '') {
        this.loading = true;

        getProviderUserList(
          Object.assign(
            {},
            { current: this.page.currentPage, size: this.page.pageSize },
            this.searchForm
          )
        )
          .then(({ data }) => {
            this.data = data.records;
            this.data.forEach(ele => {
              ele.type = ele.type+'';
              ele.sex = ele.sex+'';
            });
            this.page.total = data.total;
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      }
    },
  },
};
</script>
  
  <style scoped>
::v-deep .avue-crud__right {
  display: flex;
}
/deep/ .el-drawer__body {
  overflow: scroll !important;
}
::v-deep .avue-crud .el-form-item {
  display: block;
}

.money {
  text-align: right;
}
.txtOver {
  display: -webkit-box;
  overflow: hidden; /*超出隐藏*/
  text-overflow: ellipsis; /*隐藏后添加省略号*/
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
</style>
  <style>
#alarmRule > div > div.el-dialog__body {
  height: calc(100% - 100px);
}
</style>
  